import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "context/OAuth/authService";

const ProtectedRoute = ({ children }) => {
  const token = getAccessToken();
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
